import Form from '../../common/form';
import Joi from 'joi';

import { func } from 'prop-types';
import { getFileUploadTypes } from '../../../utils/utilities';

class PAUTWeldScanItemForm extends Form {
	state = {
		data: {
			weldNo: '',
			jointDetail: '',
			weldDrawing: [],
			metrics: '',
			result: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		weldNo: Joi.string().required().label('Weld Number'),
		jointDetail: Joi.string().min(3).required().label('Joint Detail'),
		weldDrawing: Joi.array().min(1).required().label('Weld Drawing'),
		metrics: Joi.string().min(10).required().label('Type and Length of Defect'),
		result: Joi.string().min(3).required().label('Result'),
	};

	static propTypes = {
		onAdd: func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onAdd(this.state.data);

		this.setState({
			data: {
				weldNo: '',
				jointDetail: '',
				weldDrawing: [],
				metrics: '',
				result: '',
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<h3 className="form-title">Scan Details</h3>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'weldNo',
							label: 'Weld Number',
							placeholder: 'Enter Weld Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'jointDetail',
							label: 'Joint Detail',
							placeholder: 'Joint Detail',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'metrics',
							label: 'Type and Length of Defect',
							placeholder: 'Enter Type and Length of Defect',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'result',
							label: 'Result.',
							placeholder: 'e.g. Accepted',
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: 1,
							multiple: false,
							name: 'weldDrawing',
							accept: 'image/*,application/pdf',
							label: 'Weld Drawing',
							sublabel: 'Upload Weld Drawing',
							types: getFileUploadTypes(),
						})}
					</div>
				</div>

				{this.renderButton('Add Row')}
			</form>
		);
	}
}

export default PAUTWeldScanItemForm;
